export const EditBrandInitialValues = (showData) => ({
  code: showData?.data?.code || "",
  name: showData?.data?.name || "",
  icon: null,
});
